import { FieldState, FormState } from "formstate";
import {
  validateNoWhitespace,
  validateRequired,
  validateStringMaxLength
} from "@fidget/common/utils/validatorsFormState";
import { staticConfig } from "@fidget/common/config/static-config";
import {
  AgentEditStatus,
  AgentEditStatusFields,
  AgentEditStatusForm,
  EditableStatusCreateForm,
  EditableStatusUpdateForm
} from "./types";
import { AppPresence } from "@closerplatform/spinner-openapi";
import { SpinnerService } from "../../../../services/spinner/spinnerService";

export const mapAgentEditStatusToForm = (status: AgentEditStatus): AgentEditStatusForm => {
  return new FormState<AgentEditStatusFields>({
    id: new FieldState(status.reasonSlug),
    reasonSlug: new FieldState(status.reasonSlug),
    reason: new FieldState(status.reason),
    orgId: new FieldState(status.orgId)
  });
};

export const createNewAgentEditStatusForm = (): AgentEditStatusForm => {
  const newForm = new FormState({
    id: new FieldState(""),
    reason: new FieldState(""),
    reasonSlug: new FieldState(""),
    orgId: new FieldState("")
  });

  newForm.$.reasonSlug.validators(
    validateRequired,
    validateNoWhitespace,
    validateStringMaxLength(staticConfig.statusSlugMaxCharacters)
  );
  newForm.$.reason.validators(validateRequired);

  return newForm;
};

export const copyExistingAgentEditStatusForm = (form: AgentEditStatusForm): AgentEditStatusForm => {
  const updatedForm = new FormState<AgentEditStatusFields>({
    id: new FieldState(form.$.reasonSlug.$),
    reason: new FieldState(form.$.reason.$),
    reasonSlug: new FieldState(form.$.reasonSlug.$),
    orgId: new FieldState(form.$.orgId.$)
  });

  updatedForm.$.reason.validators(validateRequired);

  return updatedForm;
};

export const mapAgentEditStatusFormToCreateForm = (
  form: AgentEditStatusForm
): EditableStatusCreateForm => {
  return {
    reasonSlug: form.$.reasonSlug.$,
    reason: form.$.reason.$
  };
};

export const mapAgentEditStatusFormToUpdateForm = (
  form: AgentEditStatusForm
): EditableStatusUpdateForm => {
  return {
    reason: form.$.reason.$
  };
};

/**
  Hopefully temporary solution - with more statuses being editable the whole thing should handle substatuses
  E.g. Service.getSubstatusesForStatus(status) wdyt?
  Or just keep it with unavailability that is editable
*/
export const crudExtractor = (status: AppPresence, spinner: SpinnerService) => {
  const unavailabilityCrud = {
    apiGetItems: () => spinner.getUnavailabilityReasons(),
    apiCreateItem: (form: EditableStatusCreateForm) => spinner.createUnavailabilityReason(form),
    apiUpdateItem: (id: string, form: EditableStatusUpdateForm) =>
      spinner.updateUnavailabilityReasons(id, form),
    apiDeleteItem: (id: string) => spinner.deleteUnavailabilityReason(id)
  };

  // switch (status) {
  //   case "unavailable":
  //     return unavailabilityCrud;
  //   default:
  //     // This is kinda bad...
  //     return unavailabilityCrud;
  // }

  return unavailabilityCrud;
};
